export class IFiltersCandidate {
  public key: string;
  public label: string;
  public value: string;

  constructor(partial: Partial<IFiltersCandidate> | string) {
    Object.assign(this, partial);
  }
}
